export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20cozy%20home%20theater%20setup%20with%20large%20screen%20showing%20colorful%20abstract%20visuals%2C%20comfortable%20couch%2C%20soft%20ambient%20lighting%20in%20coral%20and%20amber%20tones%2C%20modern%20minimalist%20living%20room%2C%20cinematic%20mood%2C%20no%20text&width=800&height=600&seq=about-peach-video&orientation=landscape"
                alt="桃子视频品牌介绍 - 温馨家庭观影场景"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              关于桃子视频
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              桃子视频是一个聚合香蕉视频、西瓜视频、蜜桃视频、樱桃视频、芒果视频、蓝莓视频、草莓视频、柠檬视频、葡萄视频、荔枝视频等水果品牌影视资源的一站式高清在线观影平台。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              我们致力于为影迷朋友们提供更新快、不缓冲、画质清晰的观影体验。无论是最新上映的热门电影、口碑爆棚的电视剧，还是轻松解压的综艺节目和热血动漫，这里都能找到你喜欢的精彩内容。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              平台每日更新上百部影视资源，覆盖动作、喜剧、爱情、悬疑、科幻、动画等多种类型，让你的闲暇时光更加丰富多彩。
            </p>
            <div className="flex flex-wrap gap-4 mt-6">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-accent-100 text-accent-500">
                  <i className="ri-check-double-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">10+</div>
                  <div className="text-xs text-foreground-500">水果品牌聚合</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-primary-100 text-primary-500">
                  <i className="ri-film-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">50000+</div>
                  <div className="text-xs text-foreground-500">影视资源库</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-secondary-100 text-secondary-500">
                  <i className="ri-user-smile-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">100万+</div>
                  <div className="text-xs text-foreground-500">活跃影迷</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}